/**
 * PMS Edge Functions Module
 *
 * Wraps all Supabase edge function invocations so the raw client
 * is never imported outside `src/integrations/pms/`.
 */

import { supabase } from '@/integrations/supabase/client';

export interface InvokeFunctionOptions {
  body?: Record<string, unknown> | FormData;
  headers?: Record<string, string>;
}

export interface FunctionResult<T = any> {
  data: T;
  error: null;
}

/**
 * Invoke a backend edge function by name.
 *
 * @example
 *   const { data } = await invokeFunction('generate-content', { body: { prompt: '...' } });
 */
export async function invokeFunction<T = any>(
  functionName: string,
  options?: InvokeFunctionOptions,
): Promise<FunctionResult<T>> {
  const { data, error } = await supabase.functions.invoke<T>(functionName, {
    body: options?.body,
    headers: options?.headers,
  });
  if (error) throw error;
  return { data: data as T, error: null };
}

/** Convenience alias matching the old `supabase.functions.invoke` pattern. */
export const pmsFunctions = {
  invoke: invokeFunction,
};
